import DatePicker from "react-multi-date-picker";

const DateRangePicker = ({ startDateValue, endDateValue, onOpen, onChange, onClose, format, placeholder, inputClass, containerClassName, minDate }) => {
  return (
    <DatePicker
      range
      value={[startDateValue, endDateValue]}
      onOpen={() => {
        onOpen();
      }}
      onChange={dateObject => {
        onChange(dateObject);
      }}
      onClose={() => {
        onClose();
      }}
      minDate={minDate || null}
      format={format}
      placeholder={placeholder}
      inputClass={inputClass}
      containerClassName={containerClassName}
    />
  );
};

export default DateRangePicker;
